// Utility to get current year dates
const getCurrentYearDates = () => {
  const year = new Date().getFullYear();
  const start = `${year}-01-01 00:00:00.000000000`;
  const end = `${year}-12-31 23:59:59.000000000`;
  return { start, end };
};

const fetchAnnualTotalisersData = async (gatewayName) => {
  try {
    const response = await fetch(
      `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/query-timestream?query_type=annual_totalisers&thing_name=${encodeURIComponent(gatewayName)}`
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error.message);
    return createEmptyDataStructure();
  }
};

// Fallback for empty data
const createEmptyDataStructure = () => ({
  months: Array(12).fill().map((_, i) => 
    new Date(Date.UTC(new Date().getFullYear(), i, 1))
      .toLocaleString('en-US', { month: 'short' })),
  Agg_Total: Array(12).fill(0),
  Bit_Total: Array(12).fill(0),
  Filler_Total: Array(12).fill(0),
  Additive_Total: Array(12).fill(0),
  RAP_Total: Array(12).fill(0),
  Gas_Total: Array(12).fill(0),
  Fuel_Total: Array(12).fill(0),
  Electric_Total: Array(12).fill(0)
});

export default fetchAnnualTotalisersData;